import { fetchTags } from '@/features/events/eventTags';
import { useQuery } from '@tanstack/react-query';

const FIVE_MINUTES_MS = 5 * 60 * 1000;

export const eventTagCatalogKeys = {
  all: ['event-tag-catalog'] as const,
};

export function useEventTagCatalog(enabled = true) {
  return useQuery({
    queryKey: eventTagCatalogKeys.all,
    queryFn: fetchTags,
    staleTime: FIVE_MINUTES_MS,
    enabled,
  });
}
